import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faCalendarMinus, faCalendarPlus, faDumbbell, faCalendar, faGauge, faSearch, faEye, faPencil, faTrashCan, faPlus, faArrowRight, faTable, faArrowUpRightFromSquare, faFilter, faRefresh, faCalendarCheck, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState } from 'recoil';
import { DateTime } from "luxon";

import { PAGE_SIZE_OPTIONS } from "../../../Constants/FieldOptions";


function SessionTemplateVideoSectionExerciseListDesktop(props) {
    const { id, vsIndex, exercises  } = props;
    return (
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Duration (Min)</th>
                    <th></th>
                </tr>
            </thead>
            {/*
            <tfoot>
                <tr>
                    <th><abbr title="Position">Pos</abbr></th>
                    <th>Team</th>
                    <th><abbr title="Played">Pld</abbr></th>
                    <th></th>
                </tr>
            </tfoot>
            */}
            <tbody>
                {exercises && <>
                    {exercises.map((object, i) => <ExerciseRow obj={object} key={i} eIndex={i} id={id} vsIndex={vsIndex} />)}
                </>}
            </tbody>
        </table>
    );
}


function ExerciseRow(props) {
    const { obj, id, vsIndex, eIndex } = props;
    if (obj === undefined) {
        return null;
    }
    const { name, duration, previewDescription, previewUrl, type, videoUrl } = obj;
    console.log(name, duration, previewDescription, previewUrl, type, videoUrl);
    return (
        <tr>
            <th>{name}</th>
            <td>{type}</td>
            <td>{duration}</td>
            <td class="is-pulled-right">
                <Link to={`/session-template/${id}/video-section/${vsIndex}/exercise/${eIndex}`} class="button is-small is-success jb-modal" data-target="sample-modal" type="button">
                    <FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View
                </Link>
                {/*
                &nbsp;&nbsp;&nbsp;
                <Link to={`/session-template/${id}/video-section/${vsIndex}/exercise/${eIndex}/edit`} class="button is-small is-warning jb-modal" data-target="sample-modal" type="button">
                    <FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Edit
                </Link>
                &nbsp;&nbsp;&nbsp;
                <button onClick={(e, ses) => onSelectExerciseForDeletion(e, obj)} class="button is-small is-danger"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                */}
            </td>
        </tr>
    );
}

export default SessionTemplateVideoSectionExerciseListDesktop;
